<template>
  <main class="banobagi-close" data-test="banobagi-close-page">
    <section class="banobagi-close__content" data-test="banobagi-close-content">
      <p class="banobagi-close__brand" data-test="banobagi-close-brand">BANOBAGI</p>
      <div class="banobagi-close__divider" aria-hidden="true"></div>
      <h1 class="banobagi-close__title" data-test="banobagi-close-title">
        {{ $t("receipt_campaign_expired") }}
      </h1>
    </section>
  </main>
</template>

<style scoped>
.banobagi-close {
  display: grid;
  min-height: 100dvh;
  place-items: center;
  padding: max(32px, env(safe-area-inset-top)) 24px
    max(32px, env(safe-area-inset-bottom));
  background: var(--secondary-color);
  color: var(--text-color);
  text-align: center;
}

.banobagi-close__content {
  width: 100%;
  max-width: 432px;
}

.banobagi-close__brand {
  margin: 0;
  color: var(--primary-color);
  font-size: var(--font-heading);
  font-weight: 600;
  letter-spacing: 0.12em;
  overflow-wrap: anywhere;
}

.banobagi-close__divider {
  width: 40px;
  height: 2px;
  margin: 28px auto;
  background: var(--primary-color);
}

.banobagi-close__title {
  margin: 0;
  font-size: var(--font-title);
  font-weight: 400;
  line-height: 1.6;
  overflow-wrap: anywhere;
}
</style>
